// E.164 doğrulaması. Backend'de PhoneNumber üzerinde hiçbir kontrol yok,
// tek kapı burası.

const MIN_DIGITS = 8;
const MAX_DIGITS = 15;

export const PHONE_RULE_TEXT =
  'Enter the phone number in international format: + country code and ' +
  `${MIN_DIGITS}-${MAX_DIGITS} digits, e.g. +905321234567.`;

export const PHONE_PLACEHOLDER = '+905321234567';

// onChange'de çağrılır: rakam ve baştaki tek "+" dışındaki her şeyi atar,
// rakam sayısını E.164 sınırında keser. Fazla/geçersiz karakter yazılamaz.
export const sanitizePhoneInput = value => {
  const raw = String(value ?? '');
  let digits = raw.replace(/\D/g, '');
  let hasPlus = raw.trimStart().startsWith('+');

  // Uluslararası çıkış kodu "00" -> "+"
  if (!hasPlus && digits.startsWith('00')) {
    hasPlus = true;
    digits = digits.slice(2);
  }

  digits = digits.slice(0, MAX_DIGITS);

  return hasPlus ? `+${digits}` : digits;
};

// Alan opsiyonel: boş değer geçerli sayılır.
export const validatePhone = value => {
  const phone = sanitizePhoneInput(value);

  if (!phone || phone === '+') {
    return { isEmpty: true, isValid: true, message: '' };
  }

  if (!phone.startsWith('+')) {
    return {
      isEmpty: false,
      isValid: false,
      message: 'Include the country code, starting with "+" (e.g. +90).',
    };
  }

  const digits = phone.slice(1);

  if (digits.startsWith('0')) {
    return {
      isEmpty: false,
      isValid: false,
      message: 'Country code cannot start with 0 (e.g. +90, not +090).',
    };
  }

  if (digits.length < MIN_DIGITS) {
    return {
      isEmpty: false,
      isValid: false,
      message: `Phone number is too short — at least ${MIN_DIGITS} digits after "+".`,
    };
  }

  if (digits.length > MAX_DIGITS) {
    return {
      isEmpty: false,
      isValid: false,
      message: `Phone number is too long — at most ${MAX_DIGITS} digits after "+".`,
    };
  }

  return { isEmpty: false, isValid: true, message: '' };
};

export const isValidPhone = value => validatePhone(value).isValid;

export default validatePhone;
